import type { DesignRoleId } from '@/config/designRoles';
import type { RoleModule } from './types';
import reception from './reception';
import clinicManager from './clinic-manager';
import accountant from './accountant';
import nurse from './nurse';
import technician from './technician';
import stockManager from './stock-manager';
import directory from './directory';
import doctor from './doctor';

/**
 * Every role's contribution, in one place. Written once and not edited per
 * role: a role changes its OWN index.tsx, never this file. See ./types.ts.
 */
export const ROLE_MODULES: Partial<Record<DesignRoleId, RoleModule>> = {
  reception,
  'clinic-manager': clinicManager,
  accountant,
  nurse,
  technician,
  'stock-manager': stockManager,
  directory,
  doctor,
};

/** Every role route, flattened for the router. */
export const ROLE_ROUTES = Object.values(ROLE_MODULES).flatMap((m) => m?.routes ?? []);

/** A role's override for one of its doors, if it declared one. */
export function doorRouteFor(surface: DesignRoleId, doorKey: string): string | undefined {
  return ROLE_MODULES[surface]?.doorRoutes?.[doorKey];
}
